import * as React from 'react';

import { JRCButtonDropdown } from 'index';
import { JRCFileViewerOpenWithOptionType } from './types';

import { useIntl } from 'react-intl';
import { jFileLittle } from 'jamespot-user-api';

type JRCFileViewerOpenWithOptionsProps = {
    file: jFileLittle;
    options: JRCFileViewerOpenWithOptionType[];
};

export const JRCFileViewerOpenWithOptions = ({ file, options }: JRCFileViewerOpenWithOptionsProps) => {
    const intl = useIntl();
    return (
        <JRCButtonDropdown
            options={options.map((o) => {
                return {
                    label: intl.formatMessage({ id: o.label }),
                    onClick: () => o.onClick(file),
                };
            })}
            small={true}
            label={intl.formatMessage({ id: 'FILE_Viewer_Open_With' })}
            color="primary"
        />
    );
};
